import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Container, Form, FormContent, FormWrap, FormH1, FormH2, FormLabel, FormButton, FormInput, IconWrap, CloseIcon } from './LoginElements'
import ScrollToTop from '../ScrollToTop'
import {useDispatch, useSelector} from 'react-redux'
import {signup} from '../Redux/Actions/sessions'


export default function Signup({loggedIn, handleGetOrders}) {
    const [signupInfo, setSignupInfo] = useState(false)
    const [userData, setUserData] = useState({
        username: "",
        password: "",
        role: "employee",
        first_name: "",
        last_name: "",
        company: ""
    })
    const dispatch = useDispatch() 
    const requesting = useSelector(state=>state.requesting)
    const errors = useSelector(state => state.errors)


    
    const navigate = useNavigate()

    useEffect(()=> {
        if (loggedIn){
            navigate("/")
        }
      }, [loggedIn])

    function handleUserData(e){
        const name = e.target.name
        const value = e.target.value


        setUserData({
            ...userData,
            [name] : value
        })
    }

    function handleSubmit(e){
        e.preventDefault();
        
        const strongParams = {
            user: {
                username: userData.username,
                password: userData.password,
                role: userData.role,
                first_name: userData.first_name,
                last_name: userData.last_name,
                company: userData.company
            }
        }
        //console.log(strongParams)
        // fetch(baseUrl + '/users',{
        //     method: "POST",
        //     headers,
        //     body: JSON.stringify(strongParams)
        // })
        // .then(resp => {
        //     if (resp.ok) {
        //         resp.json().then(data => {
        //             loginUser(data.user)
        //             localStorage.setItem('jwt', data.token)
        //             handleGetOrders(e)
        //             navigate('/dashboard')
        //     })
        //     } else {
        //         resp.json().then(e=> {
        //             for (const [key, value] of Object.entries(e)) {
        //                 setErrors(`${key}: ${value}`);
        //               }
        //         })
        //     }
        // })
        dispatch(signup(strongParams, navigate))



        setUserData({
            username: "",
            password: "",
            role: "employee",
            first_name: "",
            last_name: "",
            company: ""
        })
    }

    

    function toggleForm() {
        setSignupInfo(!signupInfo);
    } 

    // function capitalize(word) {
    //     return word[0].toUpperCase() + word.slice(1).toLowerCase();
    //   }



                    
                    
    // console.log(Object.entries(e).flat())
    return (
        <>
            <ScrollToTop/>
            <Container>
                <IconWrap to="/">
                    <CloseIcon/>
                </IconWrap>
                <FormWrap>
                    <FormContent>
                        <Form onSubmit = {handleSubmit}>
                            
                            <FormH1>Create Account:</FormH1>
                                <FormLabel htmlFor='username'>Already have an account? Sign In</FormLabel>
                                <br/>
                                <FormLabel htmlFor='company'>Company</FormLabel>
                                <FormInput  required type="text"  value={userData.company} name="company" id="company" onChange={handleUserData}/>

                                <FormLabel htmlFor='first_name'>First Name</FormLabel>
                                <FormInput  required type="text"  value={userData.first_name} name="first_name" id="first_name" onChange={handleUserData}/>

                                <FormLabel htmlFor='last_name'>Last Name</FormLabel>
                                <FormInput  required type="text"  value={userData.last_name} name="last_name" id="last_name" onChange={handleUserData}/>

                                <FormLabel htmlFor='username'>Email</FormLabel>
                                <FormInput  required type="text"  value={userData.username} name="username" id="username" onChange={handleUserData}/>
                                
                                <FormLabel htmlFor='password'>Password</FormLabel>
                                <FormInput  required type="password"  value={userData.password} name="password" id="password" onChange={handleUserData}/>
                            <FormButton type="submit">Sign Up</FormButton>
                        </Form>
                        {errors.length > 0 ? (<p style={{ color: "red" }}>{(errors)}</p>) : (null)}
                    </FormContent>
                    <FormH1>Welcome to Withthetide</FormH1>
                </FormWrap>
            </Container>
        </>
  )
}
